import AdminPolicySignaturesPage from '../../../components/admin/policies/AdminPolicySignaturesPage'

export default function PolicyDocumentDetail() {
  return <AdminPolicySignaturesPage />
}
